<template>
  <div class="sms-survey-flow-resolver">
    <div class="sms-survey-flow-resolver__loader">
      <div class="sms-survey-flow-resolver__loader__header-like" />
      <tm-spinner
        size="lg"
        color="blue"
      />
      <div class="sms-survey-flow-resolver__loader__header-like" />
    </div>
  </div>
</template>

<script setup lang="ts">
import TmSpinner from '@/components/shared/TmSpinner.vue'
</script>

<style lang="scss" scoped>
.sms-survey-flow-resolver {
  width: 100%;
  height: 100%;

  display: flex;
  flex-flow: column;
  position: relative;
  z-index: 1;
  overflow: hidden;
  background: $shade;

  &__loader {
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;

    &__header-like {
      background-color: $white;
      height: 66px;
      width: 100%;
      box-shadow: inset 0px -1px 0px $input;
    }
  }

  // background pattern
  &:before {
    content: '';
    background-image: radial-gradient($gray3 1px, transparent 1px);
    background-size: 20px 20px;
    display: block;
    position: absolute;
    left: 7px;
    right: 0;
    top: 7px;
    bottom: 0;
    z-index: -1;
  }
}
</style>
